import type { Summer2026SaleVariant } from '~/features/promotions/constants/summer-2026-sale';

import type { PromoCampaignSurfaceRenderers, RegisteredPromoCampaign } from '../types';

import { summer2026CampaignCore } from './campaign-core';
import { summer2026CampaignSurfaces } from './surfaces';

export { SUMMER_2026_CAMPAIGN_ID, summer2026CampaignCore } from './campaign-core';

const summer2026PromoCampaignTyped = {
  ...summer2026CampaignCore,
  surfaces: summer2026CampaignSurfaces,
} satisfies PromoCampaignSurfaceRenderers<Summer2026SaleVariant>;

export const summer2026PromoCampaign = summer2026PromoCampaignTyped as RegisteredPromoCampaign;
